<mat-card>
  <app-card-header
    [title]="data.contacto ? 'Detalles del contacto' : 'Detalles de la nota'"
    [icono]="data.contacto ? 'contacts' : 'note'"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <div class="dn-datos">
      @if (data.nota) {
        <span class="dn-etiqueta">Nota</span>
        <span class="dn-valor dn-nota">{{ data.nota }}</span>
      }
      @if (data.contacto) {
        <span class="dn-etiqueta">Contacto</span>
        <span class="dn-valor">{{ data.contacto }}</span>

        <span class="dn-etiqueta">Teléfono</span>
        <span class="dn-valor">
          @if (data.telefono) {
            {{ data.telefono }}
          } @else {
            <span class="no-info">Sin teléfono</span>
          }
        </span>

        <span class="dn-etiqueta">Email</span>
        <span class="dn-valor">
          @if (data.email) {
            {{ data.email }}
          } @else {
            <span class="no-info">Sin email</span>
          }
        </span>

        @if (data.numeroUsuarioAlarma) {
          <span class="dn-etiqueta">Número de usuario</span>
          <span class="dn-valor">{{ data.numeroUsuarioAlarma }}</span>
        }

        @if (
          data.tieneCodigoSeguridadNormal || data.tieneCodigoSeguridadEmergencia
        ) {
          @if (!codigosSeguridad()) {
            <span class="dn-etiqueta">Códigos de seguridad</span>
            <span class="dn-valor dn-ocultos">
              <span>Ocultos</span>
              @if (cargandoCodigos()) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                <button
                  irxBotonIcono
                  type="button"
                  (click)="verCodigosSeguridad()"
                  tooltip="Ver códigos de seguridad"
                >
                  <mat-icon>visibility</mat-icon>
                </button>
              }
            </span>
          } @else {
            @if (data.tieneCodigoSeguridadNormal) {
              <span class="dn-etiqueta">Palabra de seguridad</span>
              <span class="dn-valor">
                {{ codigosSeguridad()?.palabraSeguridadNormal }}
              </span>
            }
            @if (data.tieneCodigoSeguridadEmergencia) {
              <span class="dn-etiqueta">
                Palabra de seguridad de emergencia
              </span>
              <span class="dn-valor">
                {{ codigosSeguridad()?.palabraSeguridadEmergencia }}
              </span>
            }
          }
        }
      }
    </div>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">
      Cerrar
    </button>
  </mat-card-actions>
</mat-card>
